import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { IScrollerConfig } from '@libs/interfaces';
import { range } from 'lodash';

@Component({
  selector: 'app-scrolling-bars',
  templateUrl: './scrolling-bars.component.html',
  styleUrls: ['./scrolling-bars.component.scss'],

  imports: [CommonModule],
})
export class ScrollingBarsComponent {
  num_bars = input.required<number>();
  perc = input.required<number>();
  scrollerConfig = input<IScrollerConfig>();
  selectBar = output<number>();
  selected = computed(() => {
    const x = 100 / this.num_bars();
    return range(+this.num_bars()).reduce(
      (acum, i) => (this.perc() >= i * x && this.perc() <= (i + 1) * x ? i : acum),
      0,
    );
  });
  bars = computed(() => range(this.num_bars()));

  select(i: number) {
    this.selectBar.emit(i);
  }
}
